import { ref } from '@nuxtjs/composition-api';
import { useApolloQuery } from '@/gql/apolloWrapper';
import {
  useGetWizardsByDestinationQuery,
  WizardDestination,
  GetWizardsByDestinationQuery,
} from '@/gql/generated';
import useCurrentCompany from '@/hooks/useCurrentCompany';

// Use the generated Wizard type from GraphQL
export type Wizard = NonNullable<
  GetWizardsByDestinationQuery['wizards']
>[number];

export const useWizards = (
  destination: WizardDestination,
  force = false,
  userId?: string
) => {
  const { companyId } = useCurrentCompany();
  const wizards = ref<Wizard[]>([]);

  const { result, loading, errors, onResult, onError } = useApolloQuery(
    // @ts-ignore
    useGetWizardsByDestinationQuery,
    {
      filter: {
        companyId: companyId.value,
        destination,
        ...(userId && { userId }),
      },
    },
    undefined,
    { force }
  );

  onResult((res) => {
    if (res?.wizards) {
      wizards.value = res.wizards;
    }
  });

  onError((err) => {
    console.error('Error fetching wizards:', err);
  });

  return {
    wizards,
    loading,
    errors,
  };
};
